import { getPath } from '@/router/common'

const baseUrl = {
  title: '运力资源',
  path: 'VehicleXinghao'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'VehicleIndex',
    component: () => import(/* webpackChunkName: "VehicleIndex" */ '@/views/vehicleXinghao/index.vue'),
    meta: {
      title: '车型管理'
    }
  },
  {
    path: getPath('AddOrEdit', baseUrl),
    name: 'VehicleXinghaoAddOrEdit',
    component: () => import(/* webpackChunkName: "VehicleXinghaoAddOrEdit" */ '@/views/vehicleXinghao/addOrEdit.vue'),
    meta: {
      title: '新增车型'
    }
  },
  {
    path: getPath('wheelManagement', baseUrl),
    name: 'wheelManagement',
    component: () => import(/* webpackChunkName: "wheelManagement" */ '@/views/vehicleXinghao/wheelManagement/index.vue'),
    meta: {
      title: '车轮管理'
    }
  },
  {
    path: getPath('wheelAdd', baseUrl),
    name: 'wheelAdd',
    component: () => import(/* webpackChunkName: "wheelAdd" */ '@/views/vehicleXinghao/wheelAdd/index.vue'),
    meta: {
      title: '新增修改车轮'
    }
  }

]
